module.exports = __webpack_public_path__ + "img/ug321.99890ec4.png";